import styled, { css } from 'styled-components'
import { colors } from '../../styles'

export const StyledCustomFieldGroup = styled.div`
  margin-bottom: 16px;
  ${({ isDanger }: any) =>
    isDanger &&
    css`
      .group-label,
      .help-text {
        color: ${colors.red};
      }
    `}
` as any
